<div [formGroup]="form">
    <kal-form-field>
        <kal-input label="Code Postal"
                   [id]="id + '_code_postal'"
                   formControlName="postalCode">
        </kal-input>
    </kal-form-field>

    <kal-form-field>
        <kal-select formControlName="cityId"
                    placeholder="Sélectionner une ville"
                    label="Ville"
                    [required]="isCityRequired"
                    disableFirstOptionSelection
                    displaySearchbar>
            <kal-option [value]="null">Aucune</kal-option>
            @for (city of cityList; track city.Id) {
                <kal-option [value]="city.Id">
                    {{ city.Libelle }}
                </kal-option>
            }
        </kal-select>
        @if (!postalCodeControl.value && (cityList | arrayEmpty)) {
            <small class="gup-U-color--400 gup-U-margin-top--small">
                Vous devez saisir un code postal pour choisir une ville
            </small>
        }
    </kal-form-field>

    @if (isCountryNameFieldVisible) {
        <kal-form-field>
            <kal-input label="Pays"
                       formControlName="countryName">
            </kal-input>
        </kal-form-field>
    }

    <app-shared-icon-button (click)="openCityAddDialog()">
        Ajouter une ville
    </app-shared-icon-button>

</div>
